import { ErrorHandler, Injectable } from '@angular/core';

const CHUNK_LOAD_ERRORS = [
  'Failed to fetch dynamically imported module',
  'Importing a module script failed',
  'Unable to preload CSS',
];

function isChunkLoadError(message: string): boolean {
  return (
    CHUNK_LOAD_ERRORS.some(m => message.includes(m)) ||
    /Loading chunk [\d]+ failed/.test(message)
  );
}

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const message: string = error?.message ?? error?.reason?.message ?? '';
    if (isChunkLoadError(message)) {
      window.location.reload();
      return;
    }
    console.error(error);
  }
}
